import { ExternalFeatureLayer } from 'features/mapping/mapping.types';

export const EXTERNAL_POLYGON_LAYERS_BEFORE_ID =
  'wd-inject-external-layers-below';
export const EXTERNAL_POINT_LAYERS_BEFORE_ID =
  'wd-inject-external-point-line-layers-below';
export const EXTERNAL_LINE_LAYERS_BEFORE_ID =
  'wd-inject-external-point-line-layers-below';

export const getLayerBeforeId = (fl: ExternalFeatureLayer): string => {
  switch (fl.layerOrderSlot) {
    case 'polygon':
      return EXTERNAL_POLYGON_LAYERS_BEFORE_ID;
    case 'point':
      return EXTERNAL_POINT_LAYERS_BEFORE_ID;
    case 'line':
      return EXTERNAL_LINE_LAYERS_BEFORE_ID;
    default:
      return EXTERNAL_POLYGON_LAYERS_BEFORE_ID;
  }
};
